"use strict";
// tslint:disable
/**
 * Sleekflow General Api
 * Sleekflow General Api
 *
 * The version of the OpenAPI document: api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopifyApi = void 0;
var runtime_1 = require("../runtime");
/**
 * no description
 */
var ShopifyApi = /** @class */ (function (_super) {
    __extends(ShopifyApi, _super);
    function ShopifyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopifyApi.prototype.companyShopifyAbandonedStatisticsGet = function (_a, opts) {
        var from = _a.from, to = _a.to;
        var headers = {};
        var query = {};
        if (from != null) {
            query['from'] = from;
        }
        if (to != null) {
            query['to'] = to;
        }
        return this.request({
            url: '/company/Shopify/abandoned/statistics',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyAuthorizationUrlPost = function (_a, opts) {
        var travisBackendIntegrationServicesViewModelsBuildAuthorizationURL = _a.travisBackendIntegrationServicesViewModelsBuildAuthorizationURL;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/company/Shopify/authorization/url',
            method: 'POST',
            headers: headers,
            body: travisBackendIntegrationServicesViewModelsBuildAuthorizationURL,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyBillingOwnerGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/company/Shopify/billing-owner',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyBillingOwnerShopifyIdPost = function (_a, opts) {
        var shopifyId = _a.shopifyId;
        (0, runtime_1.throwIfNullOrUndefined)(shopifyId, 'shopifyId', 'companyShopifyBillingOwnerShopifyIdPost');
        var headers = {};
        return this.request({
            url: '/company/Shopify/billing-owner/{shopifyId}'.replace('{shopifyId}', (0, runtime_1.encodeURI)(shopifyId)),
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyCountryShopifyConfigIdPut = function (_a, opts) {
        var shopifyConfigId = _a.shopifyConfigId, travisBackendIntegrationServicesModelsUpdateSupportedCountryRequest = _a.travisBackendIntegrationServicesModelsUpdateSupportedCountryRequest;
        (0, runtime_1.throwIfNullOrUndefined)(shopifyConfigId, 'shopifyConfigId', 'companyShopifyCountryShopifyConfigIdPut');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/company/Shopify/country/{shopifyConfigId}'.replace('{shopifyConfigId}', (0, runtime_1.encodeURI)(shopifyConfigId)),
            method: 'PUT',
            headers: headers,
            body: travisBackendIntegrationServicesModelsUpdateSupportedCountryRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyDeleteIdDelete = function (_a, opts) {
        var id = _a.id;
        (0, runtime_1.throwIfNullOrUndefined)(id, 'id', 'companyShopifyDeleteIdDelete');
        var headers = {};
        return this.request({
            url: '/company/Shopify/delete/{Id}'.replace('{Id}', (0, runtime_1.encodeURI)(id)),
            method: 'DELETE',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyDiscountSettingGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/company/Shopify/discount-setting',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyDiscountSettingPost = function (_a, opts) {
        var travisBackendIntegrationServicesModelsUpdateShopifyDiscountSettingRequest = _a.travisBackendIntegrationServicesModelsUpdateShopifyDiscountSettingRequest;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/company/Shopify/discount-setting',
            method: 'POST',
            headers: headers,
            body: travisBackendIntegrationServicesModelsUpdateShopifyDiscountSettingRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyInstallGet = function (_a, opts) {
        var shop = _a.shop;
        var headers = {};
        var query = {};
        if (shop != null) {
            query['shop'] = shop;
        }
        return this.request({
            url: '/company/Shopify/install',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyIntegrateOutofboxPost = function (_a, opts) {
        var travisBackendIntegrationServicesViewModelsOutOfBoxIntegrations = _a.travisBackendIntegrationServicesViewModelsOutOfBoxIntegrations;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/company/Shopify/integrate/outofbox',
            method: 'POST',
            headers: headers,
            body: travisBackendIntegrationServicesViewModelsOutOfBoxIntegrations,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyIntegratePublicPost = function (_a, opts) {
        var travisBackendIntegrationServicesViewModelsIntegrateShoplineViewModel = _a.travisBackendIntegrationServicesViewModelsIntegrateShoplineViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/company/Shopify/integrate/public',
            method: 'POST',
            headers: headers,
            body: travisBackendIntegrationServicesViewModelsIntegrateShoplineViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyOrderStaffStatisticsGet = function (_a, opts) {
        var from = _a.from, to = _a.to, teamId = _a.teamId, offset = _a.offset, limit = _a.limit, sortBy = _a.sortBy, sortOrder = _a.sortOrder, isIncludeSystemStatistics = _a.isIncludeSystemStatistics;
        var headers = {};
        var query = {};
        if (from != null) {
            query['from'] = from;
        }
        if (to != null) {
            query['to'] = to;
        }
        if (teamId != null) {
            query['TeamId'] = teamId;
        }
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (sortBy != null) {
            query['sortBy'] = sortBy;
        }
        if (sortOrder != null) {
            query['sortOrder'] = sortOrder;
        }
        if (isIncludeSystemStatistics != null) {
            query['isIncludeSystemStatistics'] = isIncludeSystemStatistics;
        }
        return this.request({
            url: '/company/Shopify/order/staff/statistics',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyOrderStatisticsGet = function (_a, opts) {
        var from = _a.from, to = _a.to;
        var headers = {};
        var query = {};
        if (from != null) {
            query['from'] = from;
        }
        if (to != null) {
            query['to'] = to;
        }
        return this.request({
            url: '/company/Shopify/order/statistics',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyOutofboxOrderPost = function (_a, opts) {
        var travisBackendIntegrationServicesViewModelsOutOfBoxIntegrations = _a.travisBackendIntegrationServicesViewModelsOutOfBoxIntegrations;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/company/Shopify/outofbox/order',
            method: 'POST',
            headers: headers,
            body: travisBackendIntegrationServicesViewModelsOutOfBoxIntegrations,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyProductMessageTemplatePost = function (_a, opts) {
        var travisBackendIntegrationServicesModelsCreateShopifyProductMessageTemplateRequest = _a.travisBackendIntegrationServicesModelsCreateShopifyProductMessageTemplateRequest;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/company/Shopify/product-message-template',
            method: 'POST',
            headers: headers,
            body: travisBackendIntegrationServicesModelsCreateShopifyProductMessageTemplateRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyProductMessageTemplatePut = function (_a, opts) {
        var travisBackendIntegrationServicesModelsUpdateShopifyProductMessageTemplateRequest = _a.travisBackendIntegrationServicesModelsUpdateShopifyProductMessageTemplateRequest;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/company/Shopify/product-message-template',
            method: 'PUT',
            headers: headers,
            body: travisBackendIntegrationServicesModelsUpdateShopifyProductMessageTemplateRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyProductMessageTemplatesGet = function (_a, opts) {
        var shopifyConfigId = _a.shopifyConfigId;
        var headers = {};
        var query = {};
        if (shopifyConfigId != null) {
            query['shopifyConfigId'] = shopifyConfigId;
        }
        return this.request({
            url: '/company/Shopify/product-message-templates',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyRedirectUrlGet = function (_a, opts) {
        var code = _a.code, shop = _a.shop;
        var headers = {};
        var query = {};
        if (code != null) {
            query['code'] = code;
        }
        if (shop != null) {
            query['shop'] = shop;
        }
        return this.request({
            url: '/company/Shopify/redirect/url',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyStatusIdGet = function (_a, opts) {
        var id = _a.id;
        (0, runtime_1.throwIfNullOrUndefined)(id, 'id', 'companyShopifyStatusIdGet');
        var headers = {};
        return this.request({
            url: '/company/Shopify/status/{Id}'.replace('{Id}', (0, runtime_1.encodeURI)(id)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyStatusListGet = function (_a, opts) {
        var limit = _a.limit, offset = _a.offset;
        var headers = {};
        var query = {};
        if (limit != null) {
            query['limit'] = limit;
        }
        if (offset != null) {
            query['offset'] = offset;
        }
        return this.request({
            url: '/company/Shopify/status/list',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyStatusShopifyConfigIdPut = function (_a, opts) {
        var shopifyConfigId = _a.shopifyConfigId, travisBackendIntegrationServicesModelsUpdateShopifyConfigRequest = _a.travisBackendIntegrationServicesModelsUpdateShopifyConfigRequest;
        (0, runtime_1.throwIfNullOrUndefined)(shopifyConfigId, 'shopifyConfigId', 'companyShopifyStatusShopifyConfigIdPut');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/company/Shopify/status/{shopifyConfigId}'.replace('{shopifyConfigId}', (0, runtime_1.encodeURI)(shopifyConfigId)),
            method: 'PUT',
            headers: headers,
            body: travisBackendIntegrationServicesModelsUpdateShopifyConfigRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyStripeConnectionStatusShopifyIdGet = function (_a, opts) {
        var shopifyId = _a.shopifyId;
        (0, runtime_1.throwIfNullOrUndefined)(shopifyId, 'shopifyId', 'companyShopifyStripeConnectionStatusShopifyIdGet');
        var headers = {};
        return this.request({
            url: '/company/Shopify/stripe-connection-status/{shopifyId}'.replace('{shopifyId}', (0, runtime_1.encodeURI)(shopifyId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifySyncIdPost = function (_a, opts) {
        var id = _a.id;
        (0, runtime_1.throwIfNullOrUndefined)(id, 'id', 'companyShopifySyncIdPost');
        var headers = {};
        return this.request({
            url: '/company/Shopify/sync/{Id}'.replace('{Id}', (0, runtime_1.encodeURI)(id)),
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifySyncSettingIdPost = function (_a, opts) {
        var id = _a.id, travisBackendIntegrationServicesViewModelsShopifySyncSetting = _a.travisBackendIntegrationServicesViewModelsShopifySyncSetting;
        (0, runtime_1.throwIfNullOrUndefined)(id, 'id', 'companyShopifySyncSettingIdPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/company/Shopify/sync/setting/{Id}'.replace('{Id}', (0, runtime_1.encodeURI)(id)),
            method: 'POST',
            headers: headers,
            body: travisBackendIntegrationServicesViewModelsShopifySyncSetting,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyUsageIdGet = function (_a, opts) {
        var id = _a.id;
        (0, runtime_1.throwIfNullOrUndefined)(id, 'id', 'companyShopifyUsageIdGet');
        var headers = {};
        return this.request({
            url: '/company/Shopify/usage/{Id}'.replace('{Id}', (0, runtime_1.encodeURI)(id)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyWebhookCompanyIdShopifyShopifyIdCustomersPost = function (_a, opts) {
        var companyId = _a.companyId, shopifyId = _a.shopifyId, topic = _a.topic, shopifySharpCustomer = _a.shopifySharpCustomer;
        (0, runtime_1.throwIfNullOrUndefined)(companyId, 'companyId', 'companyShopifyWebhookCompanyIdShopifyShopifyIdCustomersPost');
        (0, runtime_1.throwIfNullOrUndefined)(shopifyId, 'shopifyId', 'companyShopifyWebhookCompanyIdShopifyShopifyIdCustomersPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        var query = {};
        if (topic != null) {
            query['topic'] = topic;
        }
        return this.request({
            url: '/company/Shopify/webhook/{companyId}/shopify/{shopifyId}/customers'.replace('{companyId}', (0, runtime_1.encodeURI)(companyId)).replace('{shopifyId}', (0, runtime_1.encodeURI)(shopifyId)),
            method: 'POST',
            headers: headers,
            query: query,
            body: shopifySharpCustomer,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyWebhookCompanyIdShopifyShopifyIdOrdersCreatePost = function (_a, opts) {
        var companyId = _a.companyId, shopifyId = _a.shopifyId, shopifySharpOrder = _a.shopifySharpOrder;
        (0, runtime_1.throwIfNullOrUndefined)(companyId, 'companyId', 'companyShopifyWebhookCompanyIdShopifyShopifyIdOrdersCreatePost');
        (0, runtime_1.throwIfNullOrUndefined)(shopifyId, 'shopifyId', 'companyShopifyWebhookCompanyIdShopifyShopifyIdOrdersCreatePost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/company/Shopify/webhook/{companyId}/shopify/{shopifyId}/orders/create'.replace('{companyId}', (0, runtime_1.encodeURI)(companyId)).replace('{shopifyId}', (0, runtime_1.encodeURI)(shopifyId)),
            method: 'POST',
            headers: headers,
            body: shopifySharpOrder,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyWebhookCompanyIdShopifyShopifyIdOrdersPost = function (_a, opts) {
        var companyId = _a.companyId, shopifyId = _a.shopifyId, shopifySharpOrder = _a.shopifySharpOrder;
        (0, runtime_1.throwIfNullOrUndefined)(companyId, 'companyId', 'companyShopifyWebhookCompanyIdShopifyShopifyIdOrdersPost');
        (0, runtime_1.throwIfNullOrUndefined)(shopifyId, 'shopifyId', 'companyShopifyWebhookCompanyIdShopifyShopifyIdOrdersPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/company/Shopify/webhook/{companyId}/shopify/{shopifyId}/orders'.replace('{companyId}', (0, runtime_1.encodeURI)(companyId)).replace('{shopifyId}', (0, runtime_1.encodeURI)(shopifyId)),
            method: 'POST',
            headers: headers,
            body: shopifySharpOrder,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyWebhookCompanyIdShopifyShopifyIdOrdersUpdatePost = function (_a, opts) {
        var companyId = _a.companyId, shopifyId = _a.shopifyId, shopifySharpOrder = _a.shopifySharpOrder;
        (0, runtime_1.throwIfNullOrUndefined)(companyId, 'companyId', 'companyShopifyWebhookCompanyIdShopifyShopifyIdOrdersUpdatePost');
        (0, runtime_1.throwIfNullOrUndefined)(shopifyId, 'shopifyId', 'companyShopifyWebhookCompanyIdShopifyShopifyIdOrdersUpdatePost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/company/Shopify/webhook/{companyId}/shopify/{shopifyId}/orders/update'.replace('{companyId}', (0, runtime_1.encodeURI)(companyId)).replace('{shopifyId}', (0, runtime_1.encodeURI)(shopifyId)),
            method: 'POST',
            headers: headers,
            body: shopifySharpOrder,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyWebhookCompanyIdShopifyShopifyIdUninstalledPost = function (_a, opts) {
        var companyId = _a.companyId, shopifyId = _a.shopifyId;
        (0, runtime_1.throwIfNullOrUndefined)(companyId, 'companyId', 'companyShopifyWebhookCompanyIdShopifyShopifyIdUninstalledPost');
        (0, runtime_1.throwIfNullOrUndefined)(shopifyId, 'shopifyId', 'companyShopifyWebhookCompanyIdShopifyShopifyIdUninstalledPost');
        var headers = {};
        return this.request({
            url: '/company/Shopify/webhook/{companyId}/shopify/{shopifyId}/uninstalled'.replace('{companyId}', (0, runtime_1.encodeURI)(companyId)).replace('{shopifyId}', (0, runtime_1.encodeURI)(shopifyId)),
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    ShopifyApi.prototype.companyShopifyWebhookIdGet = function (_a, opts) {
        var id = _a.id;
        (0, runtime_1.throwIfNullOrUndefined)(id, 'id', 'companyShopifyWebhookIdGet');
        var headers = {};
        return this.request({
            url: '/company/Shopify/webhook/{Id}'.replace('{Id}', (0, runtime_1.encodeURI)(id)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    return ShopifyApi;
}(runtime_1.BaseAPI));
exports.ShopifyApi = ShopifyApi;
